import { h, Component, Fragment, options } from 'preact';
import FilterComponent from './filter.component';
import { config } from '../config/config';

export default class StateFilterComponent extends Component {
    constructor() {
        super();
        this.state = {
            options: []
        };
    }

    changeDataType() {
        // console.log('%cTRACE: changeDataType', 'color: green; font-weight: 900; background: white')
        const dataType = this.props.selectedDataType;
        const geographyType = this.props.selectedGeographyType;
        // data type change update the available filter options and reset most selected filters
        let options = [];
        if (dataType && geographyType) {
            options = config.states.filter(x => {
                return x[geographyType.id].includes(dataType.id);
            });
        }

        this.setState({
            options
        });
    }

    componentDidUpdate(prevProps) {
        // console.log('%cTRACE: componentDidUpdate', 'color: green; font-weight: 900; background: white')
        if (this.props.selectedDataType !== prevProps.selectedDataType ||
            this.props.selectedGeographyType !== prevProps.selectedGeographyType) {
            // only update this if the data types have changed
            this.changeDataType();
        }
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <FilterComponent
                    options={self.state.options}
                    onSelect={(option) => self.props.toggleSelect(option)}
                    selected={self.props.selected}
                    message="Select States"
                    ga="QR Menu: State"
                />
            </Fragment>
        );
    }
}
